import { untracked } from "@suse-o11y/signal";

import { LOGIN_REDIRECT_DEEP_LINK_HASH, LocalStorage } from "~/tools/local-storage";
import type { Record } from "~/tools/record";

// Inject the header that will identify the requests coming from ajax calls
const customHeaders: Map<string, string> = new Map([["X-Requested-With", "XMLHttpRequest"]]);

export function fetch(input: Request | string, init?: RequestInit): Promise<Response> {
	const headers = (init?.headers ? init.headers : {}) as Record<string, string, "writable">;
	customHeaders.forEach((value, key) => {
		headers[key] = value;
	});

	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	return window.fetch(input, { ...init, headers }).then((response) => {
		// Redirect to the login page in case of unauthorized request.
		if (response.status === 401 || response.status === 402) {
			const locationFromHeaders = response.headers.get("Location");

			if (locationFromHeaders) {
				const redirectHashUrl = untracked((monitor) => LocalStorage.getItem(monitor, LOGIN_REDIRECT_DEEP_LINK_HASH));

				if (!redirectHashUrl) {
					LocalStorage.setItem(LOGIN_REDIRECT_DEEP_LINK_HASH, location.hash);
				}

				location.href = locationFromHeaders;
			}
		}

		if (response.status === 403) {
			throw response;
		}

		return response;
	});
}
